import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, Type } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VTableModule } from '@app/directives/_layout/v-table/v-table.module';
import { DeliveryProfileEditComponent } from '@app/main/components/resourceManagement/geofences/geofenceEditor/delivery-profile/delivery-profile-edit.component';
import { DeliveryProfileViewComponent } from '@app/main/components/resourceManagement/geofences/geofenceEditor/delivery-profile/delivery-profile-view.component';
import { GroupsModule } from '@app/main/components/resourceManagement/groups/groups.module';
import { OptimiserService } from "@components/planning/optimiser.service";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MapDirectivesModule } from "@directives/_map/_map.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { providerCreator } from "@services/_services.module";
import { PvaBarChartComponent } from "@tms/_components/pva-bar-chart/pva-bar-chart.component";
import { PvaChartLegend } from "@tms/_components/pva-bar-chart/pva-chart-legend.component";
import { RoutePerformanceBarComponent } from "@tms/_components/route-performance-bar/route-performance-bar.component";
import { ActiveRouteProgressComponent } from "@tms/_routes/activeRoutes/active-route-progress/active-route-progress.component";
import { ActiveRouteVisitComponent } from "@tms/_routes/activeRoutes/active-route-visit/active-route-visit.component";
import { ActiveRoutesComponent } from "@tms/_routes/activeRoutes/active-routes.component";
import { HistoryNotesComponent } from "@tms/_routes/history/notes/notes.component";
import { RoutePerformanceComponent } from "@tms/_routes/route-performance/route-performance.component";
import { ScheduleImportComponent } from "@tms/_routes/scheduling/_components/schedule-import/schedule-import.component";
import { AheadBehindComponent } from "@tms/_routes/visit-performance/ahead-behind/ahead-behind.component";
import { VisitPerformanceComponent } from "@tms/_routes/visit-performance/visit-performance.component";
import { ActiveRoutesService } from "@tms/_services/active-routes.service";
import { PlannedRouteAuditService } from "@tms/_services/planned-route-audit.service";
import { PlannedRouteMapService } from "@tms/_services/planned-route-map.service";
import { PlannedRouteNoteService } from "@tms/_services/planned-route-note.service";
import { PlannedRouteVisitService } from "@tms/_services/planned-route-visit.service";
import { PlannedRouteService } from "@tms/_services/planned-route.service";
import { SchedulingService } from "@tms/_services/scheduling.service";
import { UnplannedStopService } from "@tms/_services/unplanned-stop.service";
import { PipesModule } from 'src/app/_pipes/_pipes.module';
import { CloseRouteReasonComponent } from './_components/close-route/close-route-reason.component';
import { TmsHistoryComponent } from './_routes/history/tms-history.component';


const privateComponents: Type<any>[] = [

];

const publicComponents: any[] = [
    HistoryNotesComponent,
    TmsHistoryComponent,
    ActiveRoutesComponent,
    ActiveRouteVisitComponent,
    ActiveRouteProgressComponent,

    ScheduleImportComponent,
    RoutePerformanceComponent,
    RoutePerformanceBarComponent,
    VisitPerformanceComponent,
    AheadBehindComponent,
    PvaBarChartComponent,
    PvaChartLegend,

    DeliveryProfileViewComponent,
    DeliveryProfileEditComponent,
    CloseRouteReasonComponent
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    providerCreator(PlannedRouteService, "plannedRouteService"),
    providerCreator(PlannedRouteVisitService, "plannedRouteVisitService"),
    providerCreator(PlannedRouteNoteService, "plannedRouteNoteService"),
    providerCreator(UnplannedStopService, "unplannedStopService"),
    providerCreator(SchedulingService, "schedulingService"),
    providerCreator(PlannedRouteAuditService, "plannedRouteAuditService"),
    providerCreator(PlannedRouteMapService, "plannedRouteMapService"),
    providerCreator(OptimiserService, "optimiserService"),
    ActiveRoutesService
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        ScrollingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        PipesModule,
        ResourceFiltersDirectivesModule,
        MiscDirectivesModule,
        VehicleDirectivesModule,
        FormsDirectivesModule,
        MapDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        FormsModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class TmsModule {
    constructor() {
    }
}
